/* Materparade — Homepage: movimento e interazioni
   - Rivelazioni allo scroll (IntersectionObserver)
   - Hero: colore che cambia da solo o al clic, tinge Mater, sfondo e parola "colore"
   - Numeri che salgono quando entrano nello schermo
   - Configuratore: misura + colore, anteprima live e link al wizard già compilato
   - Scorrimento morbido (solo mouse/trackpad), barra di avanzamento laterale, sezione Mater 3D a passi
   Solo vanilla JS. Rispetta "riduci movimento". Niente HTML iniettato: solo textContent / style / attributi.
*/
(function () {
  'use strict';
  if (window.__mpHome) return;
  window.__mpHome = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Rivelazioni ---------- */
  function initReveal() {
    var els = $$('[data-mp-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Hero ---------- */
  function initHero() {
    var hero = $('[data-mp-hero]');
    if (!hero) return;
    var btns = $$('.mp-pick', hero);
    var nameEl = $('[data-mp-hero-name]', hero);
    if (!btns.length) return;
    var current = 0, timer = null, userChose = false;

    function set(i) {
      current = i;
      var b = btns[i];
      hero.style.setProperty('--mc', b.getAttribute('data-mp-hex'));
      btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (nameEl) nameEl.textContent = b.getAttribute('data-mp-color');
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { userChose = true; stop(); set(i); });
    });
    function start() {
      if (reduce || userChose || timer) return;
      timer = setInterval(function () { set((current + 1) % btns.length); }, 2400);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    set(0);
    start();
  }

  /* ---------- Numeri ---------- */
  function initCounters() {
    var els = $$('[data-mp-count]');
    if (!els.length) return;
    function show(el, v) { el.textContent = String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (el.getAttribute('data-mp-suffix') || ''); }
    function run(el) {
      var to = parseInt(el.getAttribute('data-mp-count'), 10) || 0;
      if (reduce) { show(el, to); return; }
      var t0 = null, dur = 1400;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        show(el, Math.round(to * eased));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    els.forEach(function (el) { show(el, 0); });
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { show(el, parseInt(el.getAttribute('data-mp-count'), 10) || 0); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Configuratore ---------- */
  function initConfigurator() {
    var root = $('[data-mp-conf]');
    if (!root) return;
    var stage = $('[data-mp-conf-stage]', root);
    var sizeBtns = $$('.mp-size', root);
    var colorBtns = $$('.mp-pick', root);
    var summary = $('[data-mp-conf-summary]', root);
    var tagSize = $('[data-mp-conf-tag-size]', root);
    var tagColor = $('[data-mp-conf-tag-color]', root);
    var cta = $('[data-mp-conf-cta]', root);
    var base = (cta && cta.getAttribute('data-mp-base')) || '/pages/su-misura';
    var state = { size: null, color: null };

    function update() {
      if (state.size) {
        stage.style.setProperty('--sc', state.size.getAttribute('data-mp-scale'));
        sizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === state.size ? 'true' : 'false'); });
        $$('.mp-conf__mark', stage).forEach(function (m) { m.classList.toggle('is-on', m.getAttribute('data-mp-cm') === state.size.getAttribute('data-mp-cm')); });
        if (tagSize) tagSize.textContent = state.size.getAttribute('data-mp-cm') + ' cm';
      }
      if (state.color) {
        stage.style.setProperty('--mc', state.color.getAttribute('data-mp-hex'));
        var m3 = $('[data-mp-3d]', stage);
        if (m3) document.dispatchEvent(new CustomEvent('mp:color', { detail: { hex: state.color.getAttribute('data-mp-hex'), root: m3 } }));
        colorBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === state.color ? 'true' : 'false'); });
        if (tagColor) tagColor.textContent = state.color.getAttribute('data-mp-color');
      }
      if (summary && state.size && state.color) {
        summary.textContent = 'Mater ' + state.color.getAttribute('data-mp-color') + ' · ' + state.size.getAttribute('data-mp-label') + ' ' + state.size.getAttribute('data-mp-cm') + ' cm';
      }
      if (cta && state.size && state.color) {
        cta.setAttribute('href', base + '?misura=' + encodeURIComponent(state.size.getAttribute('data-mp-value')) + '&colore=' + encodeURIComponent(state.color.getAttribute('data-mp-color')));
      }
    }
    sizeBtns.forEach(function (b) { b.addEventListener('click', function () { state.size = b; update(); }); });
    colorBtns.forEach(function (b) { b.addEventListener('click', function () { state.color = b; update(); }); });
    state.size = sizeBtns[sizeBtns.length - 1] || null;
    state.color = colorBtns.filter(function (b) { return b.getAttribute('data-mp-color') === 'Rosa confetto'; })[0] || colorBtns[0] || null;
    update();
  }

  /* ---------- Video ---------- */
  function initVideos() {
    var wraps = $$('[data-mp-video]');
    if (!wraps.length) return;
    wraps.forEach(function (w) {
      var v = $('video', w), btn = $('[data-mp-video-toggle]', w);
      if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('controls');
      var paused = reduce; // con "riduci movimento" parte in pausa (si vede il poster)
      function play() { if (paused) return; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      function pause() { v.pause(); }
      function sync() {
        if (!btn) return;
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Riprendi il video' : 'Metti in pausa il video');
      }
      if (btn) btn.addEventListener('click', function () { paused = !paused; sync(); if (paused) pause(); else play(); });
      sync();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) play(); else pause(); });
        }, { threshold: 0.35 }).observe(w);
      } else { play(); }
    });
  }

  /* ---------- Scorrimento morbido (stile "inerzia") ---------- */
  function initSmooth() {
    if (reduce || !$('[data-mp-smooth]')) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var html = document.documentElement;
    var cur = window.scrollY, target = cur, raf = 0, animating = false;
    function maxScroll() { return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); }
    function blocked(el) {
      if (html.style.overflow === 'hidden' || document.body.style.overflow === 'hidden' || /overflow-hidden|scroll-lock/.test(document.body.className + ' ' + html.className)) return true;
      for (var n = el; n && n !== document.body; n = n.parentElement) {
        if (!n.tagName) continue;
        var t = n.tagName;
        if (t === 'TEXTAREA' || t === 'SELECT' || t === 'DIALOG' || n.hasAttribute('data-mp-noscroll') || n.getAttribute('role') === 'dialog') return true;
        var oy = window.getComputedStyle(n).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) return true;
      }
      return false;
    }
    function tick() {
      var d = target - cur;
      if (Math.abs(d) < 0.4) { cur = target; window.scrollTo(0, cur); animating = false; raf = 0; return; }
      cur += d * 0.11;
      window.scrollTo(0, cur);
      raf = requestAnimationFrame(tick);
    }
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.defaultPrevented || e.deltaY === 0 || Math.abs(e.deltaX) > Math.abs(e.deltaY) || blocked(e.target)) return;
      e.preventDefault();
      if (!animating) { cur = window.scrollY; target = cur; }
      var dy = e.deltaMode === 1 ? e.deltaY * 32 : e.deltaMode === 2 ? e.deltaY * window.innerHeight : e.deltaY;
      target = Math.min(maxScroll(), Math.max(0, target + dy));
      if (!animating) { animating = true; raf = requestAnimationFrame(tick); }
    }, { passive: false });
    // tastiera, barra di scorrimento, link con #ancora: si risincronizza quando non stiamo animando
    window.addEventListener('scroll', function () { if (!animating) { cur = target = window.scrollY; } }, { passive: true });
  }

  /* ---------- Barra di avanzamento laterale ---------- */
  function initRail() {
    if (!$('[data-mp-smooth]')) return;
    var rail = document.createElement('div');
    rail.className = 'mp-rail'; rail.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('span'); fill.className = 'mp-rail__fill';
    var label = document.createElement('span'); label.className = 'mp-rail__label';
    rail.appendChild(fill); rail.appendChild(label); document.body.appendChild(rail);
    var map = [['.mp-hero', 'Materparade'], ['.mp-parade', 'I colori'], ['.mp-home-story', 'Le origini'], ['.mp-numbers', 'In numeri'], ['.mp-home-lines', 'Il mondo'], ['.mp-home-featured', 'Le Mater'], ['.mp-conf', 'Su misura'], ['.mp-home-news', 'Novità']];
    var secs = [];
    map.forEach(function (m) { var el = $(m[0]); if (el) secs.push({ el: el, name: m[1] }); });
    $$('[data-mp-view]').forEach(function (el) { secs.push({ el: el, name: el.getAttribute('data-mp-label') || 'La Mater' }); });
    var ticking = false;
    function update() {
      ticking = false;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      fill.style.setProperty('--p', Math.max(0, Math.min(1, window.scrollY / max)).toFixed(4));
      var mid = window.innerHeight * 0.5, name = '';
      secs.forEach(function (s) { var r = s.el.getBoundingClientRect(); if (r.top <= mid && r.bottom > mid) name = s.name; });
      if (label.textContent !== name) label.textContent = name;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Sezione Mater 3D a passi ---------- */
  function initView() {
    $$('[data-mp-view]').forEach(function (root) {
      var steps = $$('[data-mp-step]', root);
      if (!steps.length) return;
      var nameEl = $('[data-mp-view-name]', root);
      var picks = $$('.mp-pick', root);
      var chosen = null, active = -1, ticking = false;
      function color(hex) {
        root.style.setProperty('--mc', hex);
        document.dispatchEvent(new CustomEvent('mp:color', { detail: { hex: hex } }));
      }
      function setStep(i) {
        if (i === active) return;
        active = i;
        steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        var s = steps[i];
        if (s.hasAttribute('data-mp-picker')) { if (chosen) color(chosen.getAttribute('data-mp-hex')); else if (picks[0]) pick(picks[Math.min(10, picks.length - 1)], false); }
        else { var c = s.getAttribute('data-mp-color'); if (c) color(c); }
      }
      function pick(b, user) {
        chosen = b;
        picks.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (nameEl) nameEl.textContent = 'Mater ' + b.getAttribute('data-mp-color');
        color(b.getAttribute('data-mp-hex'));
      }
      picks.forEach(function (b) { b.addEventListener('click', function () { pick(b, true); }); });
      function update() {
        ticking = false;
        var r = root.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.max(0, Math.min(0.9999, -r.top / Math.max(1, r.height - vh)));
        setStep(Math.min(steps.length - 1, Math.floor(p * steps.length)));
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init() {
    document.documentElement.classList.add('mp-js');
    initReveal();
    initHero();
    initCounters();
    initConfigurator();
    initVideos();
    initView();
    initSmooth();
    initRail();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
